export default "__VITE_ASSET__CeBQVZAy__"